<template>
  <transition name="content">
    <template v-if="newMode && isLoggedIn">
      <div class="container-fluid">
      <div class="row adhoc-flex-row">
        <main-sidebar :newMode="true" v-show="isLoggedIn"></main-sidebar>
        <main class="adhoc-flex-main">
          <div class="container-fluid" style="padding-top: 20px;">
            <slot></slot>
          </div>
        </main>
      </div>
      </div>
    </template>
    <template v-else>
    <!-- Page container -->
    <div class="page-container">

      <!-- Page content -->
      <div class="page-content">

        <main-sidebar v-show="isLoggedIn"></main-sidebar>

        <!-- Main content -->
        <div class="content-wrapper">

          <div class="page-header" v-if="isLoggedIn">
            <div class="page-header-content">
              <div class="page-title" v-if="!!title">
                <h4><i class="icon-arrow-left52 position-left"></i> <span class="text-semibold">{{ title }}</span></h4>
                <a class="heading-elements-toggle"><i class="icon-more"></i></a>
              </div>
            </div>
            <breadcrumb></breadcrumb>
          </div>

          <slot name="topRightActions"></slot>

          <!-- Content area -->
          <div class="content">

            <!-- Main charts -->
            <!-- /main charts -->

            <!-- Dashboard content -->
            <slot></slot>
            <!-- /dashboard content -->

            <!-- Footer -->
            <div class="footer text-muted">
              <!-- &copy; 2015. <a href="#">Limitless Web App Kit</a> by <a href="http://themeforest.net/user/Kopyov" target="_blank">Eugene Kopyov</a> -->
            </div>
            <!-- /footer -->

          </div>
          <!-- /content area -->

        </div>
        <!-- /main content -->

      </div>
      <!-- /page content -->

    </div>
    <!-- /page container -->
    </template>
  </transition>
</template>

<script>
import Vuex from 'vuex'
import MainSidebar from '@/components/_partial/MainSidebar'
import Breadcrumb from '@/components/_partial/Breadcrumbs'

export default {
  name: 'Layout',
  components: { MainSidebar, Breadcrumb },
  props: ['title', 'newMode'],
  data () {
    return {
      showSecondary: false
    }
  },

  methods: {
    showSecondarySidebar (payload = null) {
      this.showSecondary = true
    },
    hideSecondarySidebar (payload = null) {
      this.showSecondary = false
    }
  },

  mounted () {
    this.hideSecondarySidebar()
    this.$adjustHandlers()
  },

  updated () {
    this.$adjustHandlers()
  },

  created () {
    this.$on('show-secondary-sidebar', this.showSecondarySidebar)
    this.$on('hide-secondary-sidebar', this.hideSecondarySidebar)
    if (this.isLoggedIn) {
      document.body.classList.add('navbar-top')
      document.body.classList.remove('login-container')
    } else {
      document.body.classList.remove('navbar-top')
      document.body.classList.add('login-container')
    }
  },

  watch: {
    '$route' (val, prev) {
      if (val !== prev) {
        this.hideSecondarySidebar()
      }
    },

    'showSecondary' (val) {
      if (val === false) {
        document.body.classList.add('sidebar-secondary-hidden')
      } else {
        document.body.classList.remove('sidebar-secondary-hidden')
      }
    }
  },

  computed: {
    ...Vuex.mapGetters(['isLoggedIn', 'userName', 'boxed'])
  }
}
</script>

<style scoped lang="scss">
.wide-content {
  width: 100%;
  padding: 2px 0;
  margin: 2px 0;
  margin-bottom: 0;
}

.wide-content .page-header-content {
  .page-title {
    padding-top: 5px;
    padding-bottom: 5px;
  }
}

.row.adhoc-flex-row {
  display: flex;
  // flex-wrap: wrap;
}

.adhoc-flex-main {
  .container-fluid {
    height: 100%;
  }
}
</style>
